import { createContext, useContext } from 'react';
import { useDashboardFiltersPanelContextState } from './use-dashboard-filters-panel-context-state';
import { jsx as _jsx } from "react/jsx-runtime";
const SavedDashboardFiltersPanelContext = /*#__PURE__*/createContext(undefined);
export const useSavedDashboardFiltersPanelContext = () => {
  const context = useContext(SavedDashboardFiltersPanelContext);
  if (!context) {
    throw new Error('Must access SavedDashboardFiltersPanelContext context within a context provider');
  }
  return context;
};
export const SavedDashboardFiltersPanelContextProvider = props => {
  const {
    children,
    dashboard
  } = props;
  const context = useDashboardFiltersPanelContextState(dashboard);
  return /*#__PURE__*/_jsx(SavedDashboardFiltersPanelContext.Provider, {
    value: context,
    children: children
  });
};